import React, { Component } from 'react';
import { connect } from 'react-redux';
import Table from './table';
import Datamap from './datamap';
import DistributionSelector from './distributionSelector';
import * as styles from './app.css';

class App extends Component {
  constructor() {
    super();
    this.state = {};

    this.renderError = this.renderError.bind(this);
    this.renderLoading = this.renderLoading.bind(this);
    this.renderMap = this.renderMap.bind(this);
    this.renderTable = this.renderTable.bind(this);
  }
  renderError() {
    if (this.props.error) {
      return (
        <div className={styles.loadingPlaceholder}>
          <h4 className={styles.text}>
            An error has occured when loading the data.
            <span className={styles.sub}>
              Please refresh your page, or try again later.
            </span>
          </h4>
        </div>
      );
    }
    return null;
  }

  renderLoading() {
    if (this.props.fetching) {
      return (
        <div className={styles.loadingPlaceholder}>
          <h4 className={styles.text}>
            <i
              className={
                `fa fa-circle-o-notch fa-spin fa-2x ${styles.fa}`
              }
            />
            Data are loading
          </h4>
        </div>
      );
    }
    return null;
  }

  renderMap() {
    if (!this.props.fetching &&
      !this.props.error &&
      ('map' === this.props.type || 'all' === this.props.type)
    ) {
      return (
        <div>
          <DistributionSelector />
          <Datamap />
        </div>
      );
    }
    return null;
  }

  renderTable() {
    if (!this.props.fetching && !this.props.error &&
      ('table' === this.props.type || 'all' === this.props.type)
    ) {
      return (<Table />);
    }
    return null;
  }

  render() {
    return (
      <div>
        {this.renderLoading()}
        {this.renderError()}
        {this.renderMap()}
        {this.renderTable()}
      </div>
    );
  }
}

App.propTypes = {
  error: React.PropTypes.bool,
  fetching: React.PropTypes.bool,
  type: React.PropTypes.string,
};

export default connect((state) => ({
  type: state.data.type,
  error: state.data.error,
  fetching: state.data.isFetching,
}))(App);



// WEBPACK FOOTER //
// ./app/components/app.js